/** Legacy palette colours are accents, not semantic page surfaces. */
export function engagementTheme(company: any): any {
  const components = company.componentBranding || {};
  return {
    ...company,
    backgroundColor: company.backgroundColor || components.authLoginBackgroundColor || '#0f1512',
    surfaceColor: company.surfaceColor || components.cardBackgroundColor || '#1a221e',
    textPrimaryColor: company.textPrimaryColor || components.cardTextColor || '#f7fff2',
    textSecondaryColor: company.textSecondaryColor || components.authLoginBodyTextColor || '#b5c8be',
    borderColor: company.borderColor || components.cardBorderColor || '#4f5b56'
  };
}
